export default __webpack_public_path__ + "static/media/rancho.f0cb26c8.png";